import React, { useState, useEffect, useRef } from 'react'
import './styles.scss'
import arrow from './../../../images/ico-arrow-blue.svg'
import info from './../../../images/i-ico-blue.svg'
import ModalMessage from '../../modal-message/ModalMessage';

const Select = (props) => {
    let [ activeDropdown, setActiveDropdown ] = useState(false);
    let [ value, setValue ] = useState('');
    let [ error, setError ] = useState( false );
    let [ errorText, setErrorText ] = useState();
    let [ load, setLoad ] = useState( false );
    let [ activeModal, setActiveModal ] = useState(false);
    const currentRef = useRef(null);

    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    useEffect(() => {
        if ( !load ) {
            setLoad(true);
        }
      }, [load])

      useEffect(() => {
        if(props.selectIfOne) {
            if(props.data.length == 1) {
                ;(async function() {
                    await setValue(props.data[0].val);
                    await wait(500);
                    await setError(false);
                })()
            }
        }
      }, [props.data])

      useEffect(() => {
            props.setFunction(value);
      }, [value])

    useEffect(() => {
        if ( load && !activeDropdown) {
            checkValue();
        }
    }, [activeDropdown])
    // set value
    useEffect(() => {
        if ( props.val !== value && props.val !== '') {
            setValue(props.val)
        }
    }, [props.val])
    // force validate again when clicked submit button
    // useEffect(() => {
    //     if ( load && !props.disabledForce) {
    //         checkValue();
    //     }
    // }, [props.forceValidate, props.forceValidateItems, props.forceValidateFromName])
    useEffect(() => {
        if ( load && !props.disabledForce) {
            checkValue();
        }
    }, [props.forceValidate, props.forceValidateItems, props.forceValidateFromName, props.disabledForce])

    useEffect(() => {
        if ( props.showEmptyError && value === '') {
            checkValue();
        }
    }, [props.showEmptyError])

    useEffect(() => {
        if ( props.disabledForce ) {
            setValue('')
            props.setFunction('');
            setError(false);
        } 
    }, [props.disabledForce])

    let checkValue = () => {
        if ( props.required ) {
            if ( value.length === 0 ) {
                setErrorText('Required')
                setError(true);
            } else {
                setError(false);
                if( props.forceValidateFromName ) {
                    props.setForceValidateFromName(false);
                }
            }
        }
        
        return false;
    } 

    const handleClickOutside = (event) => {
        if (currentRef.current && !currentRef.current.contains(event.target)) {
            setActiveDropdown(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={"select-wrapper single " + ( error ? 'error-item' : '')} >
            {props.label &&
                <p className="label">{props.label}</p>
            }
            <div ref={currentRef} className={"select select-columns full " + ( activeDropdown ? 'active ' : '') + ( error ? 'error ' : '') + ( value && value.length > 0 ? 'filled' : '' + ( props.disabledForce ? ' disabled-force':'' )) } onClick={ () => { if(!props.disabledForce) { setActiveDropdown(!activeDropdown) } } }>
                <span className="value"> 
                    <span id={props.id ? props.id : ''} className={(value.length == 0 || value == false) ? "placeholder-empty" : ""}>{ (value.length == 0 || value == false) ? props.label : value }</span>
                    <div className="icon">
                        <img src={ arrow } alt="Rozwiń" />
                    </div>
                </span>
                {props.placehold &&
                    <div className="placeholder">
                        <span className="underline"></span>
                        <span className="text">{ props.placehold }</span>
                    </div>
                }
                <div className={"dropdown " + ( props.toLeft ? 'left': '')}>
                    <ul className={ props.columns ? 'columns' : ''}>
                        { props.data && props.data.map( (item, index) => (
                            <>
                                { index <= props.disabledIndex && 
                                    <li key={ index } onClick={() => setValue(item.val)}>{ item.name }</li>
                                }
                                 { !props.disabledindex && typeof(props.disabledIndex) != 'number' && 
                                    <li key={ index } onClick={() => setValue(item.val)}>{ item.name }</li>
                                }
                            </>
                        ))}
                    </ul>
                </div>
            
            
            </div>
            { error && 
                <div className="error-message">
                    { errorText }
                </div>
            }
            { props.tip && 
                <img src={ info } className="tip" alt="informacja" onClick={ () => setActiveModal( true )} />
            }
            { activeModal &&
                <ModalMessage closeModal={ () => setActiveModal(false) } 
                            button={ props.button } 
                            buttonClass="blue" 
                            buttonTitle={ props.buttonTitle }
                            buttonArrow={ true } 
                            tipHeader={ props.tipHeader }
                            tipText={ props.tipText } />
            }
        </div>
    )
}

export default Select;